import './App.css';
import Home from './Home/Home';
import Navbar from './Navbar/Navbar';
import Cursos from './Cursos/Cursos';
import Catalogo from './Catalogo/Catalogo';
import Categoria from './Categoria/Categoria';
import Footer from './Footer/Footer';

import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

function App() {
  const [cursos, setCursos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [productos, setProductos] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [contact, setContact] = useState([]);

  function getCursos(){
    axios.get(process.env.REACT_APP_API_URL + "/api/cursos?populate=*")
      .then((response) => {
        setCursos(response?.data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getCategorias(){
    axios.get(process.env.REACT_APP_API_URL + "/api/categorias?populate=*")
      .then((response) => {
        var categorias = response?.data?.data;
        categorias.sort(function(a, b) {
          var dateA = new Date(a?.attributes?.updatedAt);
          var dateB = new Date(b?.attributes?.updatedAt);
          return dateA - dateB;
        });
        setCategorias(categorias);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getProductos(){
    axios.get(process.env.REACT_APP_API_URL + "/api/productos?populate=*")
      .then((response) => {
        var productos = response?.data?.data;
        productos.sort(function(a, b) {
          var dateA = new Date(a.attributes.updatedAt);
          var dateB = new Date(b.attributes.updatedAt);
          return dateA - dateB;
        });
        setProductos(productos);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getSliders(){
    axios.get(process.env.REACT_APP_API_URL + "/api/sliders?populate=*")
      .then((response) => {
        setSliders(response?.data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getContact(){
    axios.get(process.env.REACT_APP_API_URL + "/api/contact")
      .then((response) => {
        setContact(response?.data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

    useEffect(() => {
      getCategorias();
      getCursos();
      getProductos();
      getSliders();
      getContact();
    }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <div className='main-container'>
          <Navbar />
          <Routes>
            <Route path='*' element={ <Navigate to="/" /> }/>
            <Route path='/' element={<Home sliders={sliders} />} />
            <Route path='/cursos' element={<Cursos cursos={cursos}/>} />
            <Route path='/catalogo' element={<Catalogo categorias={categorias}/>} />
            <Route path='/catalogo/:categoria' element={<Categoria categorias={categorias} productos={productos}/>} />
          </Routes>
          <Footer contact={contact}/>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
